const actions = {
  SET_STATE: 'search/SET_STATE',
  LOAD: 'search/LOAD',
}

export default actions
